/* ═══════════════════════════════════════════════════════════════
   KYARNA ANIMATIONS  v1.0
   Scroll reveal · micro-interactions · premium feel
═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Helpers ───────────────────────────────────────────────── */
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function qs(sel, ctx)  { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  /* ── Intersection Observer — Scroll Reveal ─────────────────── */
  function initReveal() {
    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('k-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

    /* Section headings */
    qsa('.shopify-section h2, .shopify-section h3').forEach(function (el, i) {
      if (!el.closest('[data-no-reveal]') && !isAboveFold(el)) {
        el.classList.add('k-reveal', 'k-reveal--up');
        observer.observe(el);
      }
    });

    /* Product cards — stagger within each grid */
    qsa('.product-grid, .collection__grid, [class*="grid--"]').forEach(function (grid) {
      var cards = qsa('.card-wrapper', grid);
      grid.classList.add('k-stagger');
      cards.forEach(function (card) {
        if (!isAboveFold(card)) {
          card.classList.add('k-reveal');
          observer.observe(card);
        }
      });
    });

    /* Feature blocks / icon items */
    qsa('.icon-with-text__body, .feature-item, [class*="feature"]').forEach(function (el, i) {
      if (!isAboveFold(el)) {
        el.classList.add('k-reveal');
        el.style.transitionDelay = (i % 4) * 0.1 + 's';
        observer.observe(el);
      }
    });

    /* Collection thumbnails / category tiles */
    qsa('.collection-list__item, .collections-grid__item').forEach(function (el, i) {
      if (!isAboveFold(el)) {
        el.classList.add('k-reveal', 'k-reveal--scale');
        el.style.transitionDelay = (i % 6) * 0.08 + 's';
        observer.observe(el);
      }
    });

    /* Review cards */
    qsa('.testimonial, [class*="review"], [class*="testimonial"]').forEach(function (el, i) {
      if (!isAboveFold(el)) {
        el.classList.add('k-reveal');
        el.style.transitionDelay = (i % 3) * 0.12 + 's';
        observer.observe(el);
      }
    });

    /* Generic shopify sections (once) */
    qsa('.shopify-section:not([data-no-reveal])').forEach(function (el) {
      if (!isAboveFold(el) && !el.classList.contains('k-reveal')) {
        el.classList.add('k-reveal', 'k-reveal--fade');
        observer.observe(el);
      }
    });
  }

  function isAboveFold(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  /* ── Announcement Bar Marquee ──────────────────────────────── */
  function initMarquee() {
    var bars = qsa('.announcement-bar__message-wrapper, .announcement-bar__message');
    bars.forEach(function (bar) {
      var text = bar.textContent.trim();
      if (!text || bar.classList.contains('k-ticker')) return;

      var separator = '<span class="k-ticker__sep">✦</span>';
      var item = '<span class="k-ticker__item">' + text + separator + '</span>';
      /* Duplicate for seamless loop */
      var content = item.repeat(10);

      var ticker = document.createElement('div');
      ticker.className = 'k-ticker';
      var inner = document.createElement('div');
      inner.className = 'k-ticker__inner';
      inner.innerHTML = content + content; /* double for infinite */
      ticker.appendChild(inner);

      bar.innerHTML = '';
      bar.appendChild(ticker);
    });
  }

  /* ── Header Nav — Gold hover on current page ───────────────── */
  function initNavHighlight() {
    var path = window.location.pathname;
    qsa('.header__menu-item a, .list-menu__item a').forEach(function (a) {
      if (a.getAttribute('href') === path) {
        a.classList.add('k-gold');
        a.style.fontWeight = '500';
      }
    });
  }

  /* ── Product Image Gallery — keyboard/touch ────────────────── */
  function initProductGallery() {
    var mediaList = qs('.product__media-list');
    if (!mediaList) return;
    /* Native scroll snap is already present in Dawn;
       We add smooth transitions for thumbnails */
    qsa('.product__thumbnail').forEach(function (thumb) {
      thumb.addEventListener('mouseenter', function () {
        this.style.borderColor = 'rgba(200,160,64,.6)';
      });
      thumb.addEventListener('mouseleave', function () {
        if (!this.classList.contains('is-active')) {
          this.style.borderColor = '';
        }
      });
    });
  }

  /* ── Qty Counter — animate on change ──────────────────────── */
  function initQtyAnimations() {
    qsa('.quantity__button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.closest('.quantity')?.querySelector('.quantity__input');
        if (!input) return;
        input.style.transform = 'scale(1.12)';
        setTimeout(function () { input.style.transform = ''; }, 150);
      });
    });
  }

  /* ── Cart badge update ─────────────────────────────────────── */
  function initCartBadge() {
    /* KMB cart badge syncs with Shopify cart */
    function updateBadge(count) {
      var badge = document.getElementById('kmb-cart-badge');
      if (!badge) return;
      badge.textContent = count;
      if (count > 0) {
        badge.classList.add('on');
        badge.style.transform = 'scale(1.3)';
        setTimeout(function () { badge.style.transform = ''; }, 250);
      } else {
        badge.classList.remove('on');
      }
    }

    /* Listen for Shopify cart events */
    document.addEventListener('cart:updated', function (e) {
      if (e.detail && typeof e.detail.cartCount === 'number') {
        updateBadge(e.detail.cartCount);
      }
    });

    /* Also poll on page load */
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBadge(cart.item_count); })
      .catch(function () {});
  }

  /* ── Section title — wrap italic words ─────────────────────── */
  function initGoldTitles() {
    /* Section headings already use <em> for gold italic words.
       We add the reveal class to the em elements */
    qsa('h2 em, h3 em, .section-header__title em').forEach(function (el) {
      /* Already styled via CSS, just ensure smooth render */
      el.style.willChange = 'color';
    });
  }

  /* ── Smooth scroll for in-page anchors ─────────────────────── */
  function initSmoothLinks() {
    qsa('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = a.getAttribute('href').slice(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Gold shimmer on "Add to Cart" success ──────────────────── */
  function initATCFeedback() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.product-form__submit, .quick-add__submit, .card__atc-btn');
      if (!btn) return;
      btn.style.transition = 'box-shadow .1s';
      btn.style.boxShadow = '0 0 0 4px rgba(200,160,64,.35)';
      setTimeout(function () {
        btn.style.boxShadow = '';
        btn.style.transition = '';
      }, 400);
    });
  }

  /* ── Run all on DOM ready ───────────────────────────────────── */
  ready(function () {
    initReveal();
    initMarquee();
    initNavHighlight();
    initProductGallery();
    initQtyAnimations();
    initCartBadge();
    initGoldTitles();
    initSmoothLinks();
    initATCFeedback();

    /* Re-run reveal after dynamic content */
    document.addEventListener('shopify:section:load', function () {
      setTimeout(initReveal, 100);
    });
  });

})();
